import React from "react";
import { ProgramTemplatesScreen } from "../../../../components/screen/ProgramTemplatesScreen";

export function CoachProgramCreateRoute() {
  return <ProgramTemplatesScreen />;
}
